import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { Payment } from 'src/features/payments/utils/types';
import { PaymentFormSchemaValues } from 'src/features/payments/utils/formSchema';

const RESOURCE = '/payments/payment/:paymentId/';

type MutationFnType = typeof mutationFn;

interface DTO extends PaymentFormSchemaValues {
    paymentId: string;
}
const mutationFn = ({ paymentId, ...data }: DTO): Promise<Payment> => {
    return axios.put(formatResourcePath(RESOURCE, { paymentId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdatePayment };
